var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errorMessages.length > 0)?_c('pc-tooltip',{attrs:{"value":_vm.errorMessages.join('<br>')}},[_c('span',{staticClass:"error-bullet"},[_vm._v(_vm._s(_vm.errorMessages.length))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }